import { useEffect, useState } from "react";

export const Team = ({ data }) => {
  const [selectedMember, setSelectedMember] = useState(null);
  const [containerWidth, setContainerWidth] = useState("70%");

  useEffect(() => {
    const updateWidth = () => {
      const width = window.innerWidth;
      if (width < 1400 && width >= 1024) {
        setContainerWidth("90%");
      } else if (width < 1024) {
        setContainerWidth("95%");
      } else {
        setContainerWidth("70%");
      }
    };

    updateWidth();
    window.addEventListener("resize", updateWidth);
    return () => window.removeEventListener("resize", updateWidth);
  }, []);

  return (
    <div>
      <section
        id="team"
        style={{
          padding: "60px 20px",
          backgroundColor: "#f9fafb",
          textAlign: "center",
          borderTop: "1px solid #DDD",
          borderBottom: "1px solid #DDD",
        }}
      >
        <div style={{ maxWidth: 1500, margin: "0 auto" }}>
          <h2
            style={{
              fontSize: "2.8rem",
              fontWeight: "700",
              marginBottom: "54px",
              color: "#111827",
              position: "relative",
              display: "inline-block",
            }}
          >
            Leadership Team
            <span
              style={{
                position: "absolute",
                width: "50%",
                height: "4px",
                backgroundColor: "#C38745",
                left: 0,
                bottom: -10,
              }}
            ></span>
          </h2>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(140px, 1fr))",
              justifyItems: "center",
              gap: '1rem'
            }}
          >
            {data ? (
              data.map((member, i) => (
                <div
                  key={`${member.name}-${i}`}
                  style={{
                    backgroundColor: "white",
                    boxShadow: "0 10px 20px rgba(0,0,0,0.08)",
                    padding: "16px 12px",
                    maxWidth: "240px",
                    width: "100%",
                    cursor: "pointer",
                    transition: "transform 0.3s ease, box-shadow 0.3s ease",
                  }}
                  onClick={() => setSelectedMember(member)}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "translateY(-8px)";
                    e.currentTarget.style.boxShadow =
                      "0 20px 30px rgba(0,0,0,0.15)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.boxShadow =
                      "0 10px 20px rgba(0,0,0,0.08)";
                  }}
                >
                  <img
                    src={member.img}
                    alt={member.name}
                    loading="lazy"
                    style={{
                      width: "140px",
                      height: "190px",
                      objectFit: "cover",
                      border: "4px solid #C38745",
                      marginBottom: "10px",
                      boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                    }}
                  />
                  <h4
                    style={{
                      fontSize: "1.4rem",
                      fontWeight: "600",
                      color: "#111827",
                      marginBottom: "8px",
                    }}
                  >
                    {member.name}
                  </h4>
                  {(() => {
                    const [title, short] = member.job.split(" (");
                    return (
                      <p
                        style={{
                          color: "#6B7280",
                          fontSize: "1.3rem",
                          margin: 0,
                          fontStyle: "italic",
                          whiteSpace: "normal",
                        }}
                      >
                        {title}
                        <br />
                        ({short?.replace(")", "")})
                      </p>
                    );
                  })()}
                </div>
              ))
            ) : (
              <p style={{ color: "#6B7280" }}>Loading...</p>
            )}
          </div>

          {selectedMember && (
            <div
              onClick={() => setSelectedMember(null)}
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100vw",
                height: "100vh",
                backgroundColor: "rgba(0,0,0,0.6)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 9999,
                padding: 20,
                overflow: "auto",
                cursor: "zoom-out",
              }}
            >
              <div
                onClick={(e) => e.stopPropagation()}
                style={{
                  backgroundColor: "#fff",
                  padding: "20px",
                  maxWidth: "min(600px, 90vw)",
                  boxShadow: "0 10px 30px rgba(0,0,0,0.4)",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  textAlign: "center",
                }}
              >
                <img
                  src={selectedMember.img}
                  alt={selectedMember.name}
                  loading="lazy"
                  style={{
                    width: "300px",
                    height: "375px",
                    objectFit: "cover",
                    marginBottom: "24px",
                    boxShadow: "0 6px 12px rgba(0,0,0,0.2)",
                  }}
                />
                <h3 style={{ fontSize: "1.8rem", color: "#111827", marginBottom: 8 }}>
                  {selectedMember.name}
                </h3>
                {/* <p style={{ color: "#6B7280", fontSize: "1.2rem", fontStyle: "italic" }}>
                  {selectedMember.job}
                </p> */}
                {selectedMember.bio && (
                  <p
                    style={{
                      color: "#4B5563",
                      fontSize: "1.2rem",
                      marginTop: "10px",
                      maxWidth: 600,
                      lineHeight: 1.7,
                      whiteSpace: "pre-wrap",
                    }}
                  >
                    {selectedMember.bio}
                  </p>
                )}
              </div>
            </div>
          )}
        </div>
      </section>

      {/* Our Commitment Section */}
      <section
        style={{
          backgroundColor: "#fff",
          padding: "80px 20px",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <div
          style={{
            width: containerWidth,
            backgroundColor: "#fff",
            border: "1px solid #e5e7eb",
            boxShadow: "0 10px 30px rgba(0,0,0,0.05)",
            padding: "60px 40px",
            textAlign: "center",
          }}
        >
          <h2
            style={{
              fontSize: "2.4rem",
              fontWeight: "700",
              marginBottom: "50px",
              color: "#111827",
              position: "relative",
              display: "inline-block",
            }}
          >
            Our Commitment
            <span
              style={{
                position: "absolute",
                width: "50%",
                height: "4px",
                backgroundColor: "#C38745",
                left: "25%",
                bottom: -10,
              }}
            ></span>
          </h2>

          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "space-between",
              gap: "32px",
              marginTop: "40px",
            }}
          >
            {[
              {
                icon: "fa-leaf",
                color: "#10B981",
                title: "Premium Quality",
                desc: `We deliver fresh, nutritious products that meet Canada’s strict food safety standards — always natural, wholesome, and free from unnecessary additives.`,
              },
              {
                icon: "fa-users",
                color: "#F59E0B",
                title: "Community Impact",
                desc: `We invest in rural revitalization by transforming idle farmlands and renewing local infrastructure to generate stable jobs and vibrant communities in Alberta.`,
              },
              {
                icon: "fa-recycle",
                color: "#3B82F6",
                title: "Sustainability",
                desc: `We champion responsible farming and production practices that protect our environment, our people, and future generations.`,
              },
            ].map((item, idx) => (
              <div key={idx} style={{ flex: "1 1 280px", minWidth: 280 }}>
                <div
                  style={{
                    fontSize: "4.5rem",
                    color: item.color,
                    marginBottom: "16px",
                  }}
                >
                  <i className={`fa ${item.icon}`}></i>
                </div>
                <h3
                  style={{
                    fontSize: "2rem",
                    fontWeight: 600,
                    marginBottom: "10px",
                    color: "#111827",
                  }}
                >
                  {item.title}
                </h3>
                <p
                  style={{
                    color: "#4B5563",
                    fontSize: "1.5rem",
                    lineHeight: 1.6,
                  }}
                >
                  {item.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};
